import { render, staticRenderFns } from "./ReviewOpinionSheet.vue?vue&type=template&id=3386355e&scoped=true"
import script from "./ReviewOpinionSheet.vue?vue&type=script&lang=js"
export * from "./ReviewOpinionSheet.vue?vue&type=script&lang=js"
import style0 from "./ReviewOpinionSheet.vue?vue&type=style&index=0&id=3386355e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3386355e",
  null
  
)

export default component.exports